import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { get_mentor_profile_data_action } from "../../../../redux/_actions/mentor/mentor.actions";

function useProfile(props) {
  const [userData, setUserData] = useState({});
  const dispatch = useDispatch();


  //get data from redux
  const { mentorProfileData } = useSelector(
    (state) => state.get_mentor_profile_data_reducer
  );

  useEffect(() => {
    callApi();
  }, []);


  useEffect(() => {
    if (mentorProfileData?.data) {
      setUserData(mentorProfileData?.data);
    }
  }, [mentorProfileData]);

  const callApi = async () => {
    await dispatch(get_mentor_profile_data_action());
  }
  return {
    userData,
  };
}
export default useProfile;
